// This standardizes all the signature verification states
// into a single map.
const SIGNATURE = {
  NOT_VERIFIED_YET: "NOT_VERIFIED_YET",
  INVALID: "INVALID",
  VALID: "VALID",
};
export default SIGNATURE;
